import React, {Component} from 'react';

import Image from 'next/image';
import styled from 'styled-components';

import pricayIcon from 'Frontend/assets/images/dataPrivacyIcon';
import {FONTS} from 'Frontend/utils/fonts';
import {clampCss, pxToVw} from 'Frontend/utils/helpers';
import {MEDIA} from 'Frontend/utils/mediaQueries';


/**
 * Features
 *
 * @property {*} prop Prop comment.
 *
 * @class Features
 * @extends {Component}
 */
class Features extends Component {
    /**
     * Renders the Component.
     *
     * @returns {JSX} Component.
     * @memberof Features
     */
    render() {
        return (
            <FeatureContainer>
                <FeatureList>
                    <FeatureListItem>Anbieterkontakt nur mit deiner Zustimmung</FeatureListItem>
                    <FeatureListItem>
                        Unverbindliche Beratung durch unsere Zweithaarstudios
                    </FeatureListItem>
                    <FeatureListItem>100% kostenlos</FeatureListItem>
                </FeatureList>
                <ImageContainer>
                    <Image height={200} src={pricayIcon} width={200} />
                </ImageContainer>
            </FeatureContainer>
        );
    }
}

export default Features;

const ImageContainer = styled.div`
    display: none;
    padding-left: 10px;

    ${MEDIA.TABLET.UP} {
        display: none;
    }

    ${MEDIA.DESKTOP.UP} {
        display: block;
    }
`;

const FeatureList = styled.ul`
    font-size: ${clampCss(12, 'm')};
    letter-spacing: ${clampCss(0.5, 'm')};
    line-height: ${clampCss(16.8, 'm')};
    ${FONTS.REGULAR}

    padding-bottom: ${clampCss(20, 'm')};
    padding-left: 1rem;
    padding-top: ${clampCss(20, 'm')};

    ${MEDIA.TABLET.UP} {
        font-size: ${clampCss(12, 't')};
        letter-spacing: ${clampCss(0.5, 't')};
        line-height: ${clampCss(16.8, 't')};
        padding-bottom: ${clampCss(20, 't')};
        padding-top: ${clampCss(20, 't')};
    }

    ${MEDIA.DESKTOP.UP} {
        font-size: max(12px, ${pxToVw(12, 'd')});
        letter-spacing: max(0.5px, ${pxToVw(0.5, 'd')});
        line-height: max(16.8px, ${pxToVw(16.8, 'd')});
        padding-bottom: max(20px, ${pxToVw(20, 'd')});
        padding-top: max(20px, ${pxToVw(20, 'd')});
    }
`;

const FeatureListItem = styled.li`
    padding-bottom: 8px;
`;

const FeatureContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
`;